import script from "./TalentTestimonial.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentTestimonial.vue?vue&type=script&setup=true&lang=js"

import "./TalentTestimonial.vue?vue&type=style&index=0&id=4cb3251f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb3251f"]])

export default __exports__